// imports section Start
import React from "react";
import AppBar from "@mui/material/AppBar";
import { Box, Button } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { useState, useEffect } from "react";
import { useTheme, styled } from "@mui/material/styles";
import AppsIcon from "@mui/icons-material/Apps";
import AdbIcon from "@mui/icons-material/Adb";
import Switch from "@mui/material/Switch";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lightTheme, darkTheme } from "../../assets/styles/Theme";
import { useStyles } from "../../assets/styles/Theme";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { resetUserParams } from "../../store/ReduxUser";
import { clearCashierCart } from "../../store/ReduxCashierCartReducer";
import { useNavigate, Link } from "react-router-dom";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_MODULE_SYSADMIN,
} from "../../utils/sys/Constants";
import CameraIcon from "@mui/icons-material/Camera";
import { useSelector, useDispatch } from "react-redux";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// imports section End
import { ListItemIcon } from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import { BorderColor } from "@mui/icons-material";
import { LOGIN_API, LOGOUT_API } from "../../api/ApiModel";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import * as Icons from "@mui/icons-material";

const getIconComponent = (iconName) => {
  return Icons[iconName] || Icons["HelpOutline"];
};
const Navbar = ({ toggleTheme }) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [anchorEl, setAnchorEl] = useState({});
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState("");

  //const [accessModules, setAccessModules] = useState([]);
  const accessModules = useSelector((state) => state.accessModules);
  const [currentDateTime, setCurrentDateTime] = useState(
    new Date().toLocaleString("en-US", {
      weekday: "short", // Use 'short' for abbreviated day names
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    })
  );

  useEffect(() => {
    const timer = setInterval(() => {
      const formattedDate = new Date().toLocaleString("en-US", {
        weekday: "short", // Use 'short' for abbreviated day names
        year: "numeric",
        month: "long",
        day: "numeric",
        // hour: "numeric",
        // minute: "numeric",
        // second: "numeric",
      });

      // Remove the suffixes from the day
      const cleanedDate = formattedDate.replace(/\b(\d+)(st|nd|rd|th)\b/, "$1");

      setCurrentDateTime(cleanedDate);
    }, 1000); // Use 1000ms for a 1-second interval

    return () => clearInterval(timer);
  }, []);

  const [checked, setChecked] = useState(true);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const {
    COMPCODE,
    LOCCODE,
    RESTCODE,
    USERNAME,
    COMPNAME,
    USERREFCODE,
    TEMPKEY,
  } = SYS_USER.USER_PARAM || {};

  // Handlers start

  const pages = ["Products", "Pricing", "Blog"];
  const settings = ["Profile", "Account", "Dashboard", "Logout"];

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const goToPage = () => {
    navigate("/View");
  };

  const accessModulesArray = Array.isArray(accessModules)
    ? accessModules
    : Object.values(accessModules).filter(
        (item) => item.MODULECODE !== undefined
      );

  useEffect(() => {}, [accessModulesArray]);

  const groupedaccessModules =
    accessModulesArray.length > 0
      ? accessModulesArray.reduce((acc, curr) => {
          const {
            MODULECODE,
            MODULENAME,
            MODULEICON,
            MODULEURL, // Ensure MODULEURL is destructured here
          } = curr;

          // Check if the module already exists in the accumulator
          if (!acc[MODULECODE]) {
            acc[MODULECODE] = {
              MODULECODE,
              MODULENAME,
              MODULEICON, // Add MODULEICON at the module level
              MODULEURL, // Add MODULEURL at the module level
              // Initialize an array for menu items
            };
          }

          return acc;
        }, {})
      : {};

  // const handleMenuItemClick = (path, closeFunction) => {
  //   closeFunction();
  //   navigate(path);
  // };

  const handleMenuItemClick = (moduleData, closeFunction) => {
    const { MODULEURL, MODULECODE } = moduleData;
    console.log("modulecode", MODULECODE);
    console.log("MODULEURL", MODULEURL);

    // Construct the URL with query parameters
    const url = `${MODULEURL}ModuleTransfer?username=${encodeURIComponent(
      USERNAME
    )}&tempkey=${encodeURIComponent(TEMPKEY)}&modulecode=${encodeURIComponent(
      MODULECODE
    )}`;

    // Close the menu and navigate
    closeFunction();
    window.location.assign(url);
  };

  const handleLogout = async () => {
    try {
      // Call the Logout API
      const logoutPayload = {
        compcode: COMPCODE, // Replace with your dynamic compcode
        userrefcode: String(USERREFCODE), // Replace with the user's refcode from Redux or state
        username: USERNAME, // Replace with the logged-in username from Redux or state
      };

      const logoutResponse = await externalpostApi(LOGOUT_API, logoutPayload); // Replace LOGOUT_API with the actual endpoint

      if (logoutResponse) {
        // Logout successful
        dispatch(resetUserParams()); // Clear user parameters from Redux
        dispatch(clearCashierCart()); // Clear cashier cart or other app states
        navigate("/Login"); // Redirect to login page
        setAnchorEl((prev) => ({ ...prev, logout: null })); // Reset dropdown state if applicable
      } else {
        console.error("Logout failed:", logoutResponse.message);
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  // Handlers end

  return (
    <AppBar sx={styles.AI_CustomAppBar}>
      <Box>
        <Toolbar sx={styles.nv_CustomToolbar}>
          <Box
            sx={{
              ml: { xs: 3, sm: 3, md: 8 },
            }}
          >
            <Typography sx={styles.header_title}>{COMPNAME}</Typography>
            <Typography sx={styles.header_date}> {currentDateTime}</Typography>
          </Box>
          <br />
          <Box sx={styles.nv_CustomBox} />{" "}
          {/* <Switch
            sx={styles.Muiswitch_Navbar}
            onChange={toggleTheme}
            inputProps={{ "aria-label": "controlled" }}
          /> */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            gap={2}
          >
            <Box
              sx={{
                border: `1px solid ${theme.palette.input_field.stroke}`,
                boxShadow: 1,
                borderRadius: 10,
                px: 1,
                "@media (max-width: 600px)": {
                  display: "none",
                },
              }}
            >
              {" "}
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  background: theme.palette.text.secondary,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  // marginRight: 1,
                  p: "2px",
                  backgroundColor: theme.palette.text.secondary,
                }}
              >
                {USERNAME}
              </Typography>
            </Box>

            <Tooltip title="Modules" arrow>
              <IconButton
                onClick={handleOpenNavMenu}
                sx={{
                  p: 0.5,
                  borderRadius: "50%",
                  border: `1px solid ${theme.palette.input_field.stroke}`,
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 0 8px #333"
                      : "0 0 8px #ddd",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                    transform: "scale(1.05)",
                    transition: "all 0.3s ease-in-out",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                    overflow: "hidden",
                    backgroundColor: theme.palette.background.default,
                  }}
                >
                  <AppsIcon
                    sx={{
                      color: theme.palette.primary.main,
                      width: 39, // Adjust size as needed
                      height: 34,
                    }}
                    alt="menu"
                  />
                </Box>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{
                mt: "45px",
                "& .MuiMenu-paper": {
                  // borderRadius: "12px",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                  // backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  // padding: "8px 0",
                  my: 0,
                },
              }}
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Grid
                container
                spacing={1}
                sx={{
                  // maxWidth: "380px",
                  // borderRadius: "12px",
                  px: 2,
                  py: 1,
                  // boxShadow: `4px 4px 4px 0px ${theme.palette.input_field.stroke}`,
                  backgroundColor: theme.palette.background.paper,
                }}
              >
                {Object.entries(groupedaccessModules).map(
                  ([moduleCode, moduleData]) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      // md={6}
                      // lg={6}
                      // xl={6}
                      key={moduleCode}
                      sx={{
                        minWidth:
                          Object.keys(groupedaccessModules).length === 1
                            ? "200px"
                            : "auto",
                      }}
                      // width={"100%"}
                    >
                      <MenuItem
                        onClick={() =>
                          handleMenuItemClick(moduleData, handleCloseNavMenu)
                        }
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          // padding: "8px",
                          width: "100%",
                          px: 1,

                          boxShadow: 1,
                          "&:hover": {
                            backgroundColor: theme.palette.action.hover,
                            borderRadius: "8px",
                          },
                        }}
                      >
                        <IconButton
                          sx={{
                            backgroundColor: theme.palette.grey[100],
                            width: "56px",
                            height: "56px",
                            marginBottom: "8px",
                            boxShadow: 1,
                            "&:hover": {
                              backgroundColor: theme.palette.primary.light,
                              color: theme.palette.text.buttontxt,
                            },
                          }}
                        >
                          {React.createElement(
                            getIconComponent(moduleData.MODULEICON)
                          )}
                        </IconButton>
                        <Typography
                          variant="body2"
                          align="center"
                          sx={{
                            fontWeight: 500,
                            color: theme.palette.text.primary,
                          }}
                        >
                          {moduleData.MODULENAME}
                        </Typography>
                      </MenuItem>
                    </Grid>
                  )
                )}
              </Grid>
            </Menu>

            <Tooltip title="Profile Options" arrow>
              <IconButton
                onClick={handleOpenUserMenu}
                sx={{
                  p: 0.5,
                  borderRadius: "50%",
                  border: `1px solid ${theme.palette.input_field.stroke}`,
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 0 8px #333"
                      : "0 0 8px #ddd",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                    transform: "scale(1.05)",
                    transition: "all 0.3s ease-in-out",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                    overflow: "hidden",
                    backgroundColor: theme.palette.background.default,
                  }}
                >
                  <AccountCircleRoundedIcon
                    alt="Remy Sharp"
                    src="/static/images/avatar/2.jpg"
                    sx={{
                      width: "100%",
                      height: "100%",
                      color: theme.palette.primary.main,
                    }}
                  />
                </Box>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{
                mt: "45px",
                "& .MuiMenu-paper": {
                  borderRadius: "12px",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                  backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  padding: "8px 0",
                },
              }}
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem
                onClick={() => {
                  navigate("/myprofile");
                }
                }
                sx={{
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                    "& .MuiSvgIcon-root": {
                      color: theme.palette.secondary.main,
                    },
                  },
                }}
              >
                <IconButton sx={{ mr: 1 }}>
                  <AccountCircleIcon
                    sx={{ color: theme.palette.primary.main }}
                  />
                </IconButton>
                <Typography textAlign="center">My profile</Typography>
              </MenuItem>
              <MenuItem
                // onClick={() =>
                //   handleMenuItemClick("/ChangePassword", () =>
                //     setAnchorElUser(null)
                //   )
                onClick={() => {
                  navigate("/ChangePassword");
                }
                }
                sx={{
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                    "& .MuiSvgIcon-root": {
                      color: theme.palette.secondary.main,
                    },
                  },
                }}
              >
                <IconButton sx={{ mr: 1 }}>
                  <LockResetIcon sx={{ color: theme.palette.primary.main }} />
                </IconButton>
                <Typography>Change Password</Typography>
              </MenuItem>

              <MenuItem
               onClick={() => navigate("/")}
                sx={{
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                    "& .MuiSvgIcon-root": {
                      color: theme.palette.secondary.main,
                    },
                  },
                }}
              >
                <IconButton sx={{ mr: 1 }}>
                  <ExitToAppIcon sx={{ color: theme.palette.primary.main }} />
                </IconButton>
                <Typography textAlign="center"> Log Out</Typography>
              </MenuItem>
            </Menu>
          </Box>{" "}
        </Toolbar>
      </Box>
    </AppBar>
  );
};

export default Navbar;
